<!--
 * @Description: 导出下载中心 新
-->

<template>
  <el-dialog :title="lang('导出文件下载')" :visible.sync="showDialog" top="12vh" class="network-download-dialog" width="850px" @closed="dialogClosed" :close-on-click-modal="false">
    <div class="network-download-dialog" v-show="showDialog">
      <div class="search">
        <div>
          <span class="btns">
            <el-button type="primary" @click="searchChange" :loading="loading" class="btn-query" icon="el-icon-search">{{ lang('查 询') }}</el-button>
            <el-button @click="searchReset" icon="el-icon-refresh-right">{{ lang('清 空') }}</el-button>
          </span>
        </div>
        <el-form v-model="slotParams" :inline="true" label-suffix=" :" label-position="top" class="avue-crud__search">
          <el-form-item label="文件名称">
            <el-input v-model="slotParams.jobName" clearable></el-input>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="slotParams.operatingStartTime"
              style="width: 200px"
              type="datetime"
              default-time="00:00:00"
              value-format="yyyy-MM-dd HH:mm:ss"
              :editable="false"
              :picker-options="pickerOptionsStart"
              :clearable="false"
              :placeholder="$lang('开始日期')"
            >
            </el-date-picker>
            <el-date-picker
              class="time-item"
              v-model="slotParams.operatingEndTime"
              type="datetime"
              style="width: 200px;margin-left: 10px"
              :editable="false"
              default-time="23:59:59"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptionsEnd"
              :clearable="false"
              :placeholder="$lang('结束日期')"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="export-warning">
        <el-alert title="系统只保留最近7天生成的文件，过期将自动清理，请及时下载！" type="warning" show-icon :closable="false"></el-alert>
      </div>
      <avue-crud
        ref="table"
        :option="listOpt"
        :data="listData"
        :table-loading="loading"
        :page="page"
        @size-change="sizeChange"
        @current-change="currentChange"
        @search-change="searchChange"
      >
        <template slot="menu" slot-scope="{ row }">
          <el-button type="text" @click="downloadMethed(row)" :title="lang('下载')" v-if="row.statusType === 1" :loading="row.btnLoading">{{ lang('下载') }}</el-button>
        </template>
      </avue-crud>
    </div>
  </el-dialog>
</template>
<script>
import { RESPONSE_CODE } from '@public/http/config'
import { lang } from '@public/utils/filters.js'
import store from '@store'
import { taskCenter } from '../pool'
import { commonFun } from '@public/utils/common'
const dayTime = 24 * 3600 * 1000 // 一天的毫秒数
export default {
  name: 'ExportDownloadDialog',
  data() {
    return {
      loading: false, // 绑定dialog开关 动态启停定时器
      showDialog: false,
      listData: [],
      page: {
        current: 1,
        size: 20,
        total: 0
      },
      slotParams: {
        operatingStartTime: commonFun.GetTodayDate()[0],
        operatingEndTime: commonFun.GetTodayDate()[1]
      },
      timer: null,
      COM_HTTP: taskCenter,
      modelType: '',
      downUrl: ''
    }
  },
  methods: {
    lang,
    // avue-查询方法
    async getListData() {
      // 传入参数有current
      const { staffNo } = store.state.base.user
      const params = { ...this.page, operatorCode: staffNo, modelType: this.modelType, ...this.slotParams, gatewayType: this.gatewayType }
      try {
        this.loading = true
        const { code, data, msg } = await this.COM_HTTP.reqList(params)
        this.loading = false
        if (code === RESPONSE_CODE.SUCCESS) {
          this.listData = data.records || []
          this.page.total = data.total || 0
          this.page.current = data.current || 1
        } else {
          this.$message.error(msg)
          clearInterval(this.timer)
        }
      } catch (error) {
        console.error(error)
        clearInterval(this.timer)
        this.loading = false
      }
    },
    // 选择分页条数
    sizeChange(val) {
      this.page.current = 1
      this.page.size = val
      this.getListData()
    },
    // 跳转页码
    currentChange(val) {
      this.page.current = val
      this.getListData()
    },
    // 触发按钮查询
    searchChange() {
      this.page.current = 1
      this.getListData()
    },
    searchReset() {
      this.slotParams.jobName = ''
      this.slotParams.operatingStartTime = commonFun.GetTodayDate()[0]
      this.slotParams.operatingEndTime = commonFun.GetTodayDate()[1]
      this.page.current = 1
      this.page.size = 20
    },
    open(modelType, moduleName, gatewayType) {
      this.showDialog = true
      this.modelType = modelType
      this.moduleName = moduleName
      this.gatewayType = gatewayType
      this.slotParams = {
        operatingStartTime: commonFun.GetTodayDate()[0],
        operatingEndTime: commonFun.GetTodayDate()[1]
      }
      this.getListData()
    },
    dialogClosed() {
      clearInterval(this.timer)
      this.searchReset()
      this.listData = []
    },
    destroyed() {
      clearInterval(this.timer)
    },
    async downloadMethed(row) {
      const params = {
        fileUrl: row.fileUrl,
        moduleName: this.moduleName,
        fileName: row.jobName,
        gatewayType: this.gatewayType
      }
      this.$set(row, 'btnLoading', true)
      row.btnLoading = true
      const { code, msg, data } = await this.COM_HTTP.getFileUrl(params)
      if (code === RESPONSE_CODE.SUCCESS) {
        const elink = document.createElement('a')
        elink.style.display = 'none'
        elink.href = data
        console.log(row.jobName)
        elink.setAttribute('download', this.$lang(row.jobName) + '.xls')
        document.body.appendChild(elink)
        elink.click()
        this.$set(row, 'btnLoading', false)
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      } else {
        this.$message.error(msg)
      }
    }
  },
  computed: {
    pickerOptionsStart() {
      const space = this.hanldeDayRange * dayTime // 最小可操作的时间范围
      return {
        disabledDate: dateTime => {
          const maxTime = new Date(this.$taday.end).getTime()
          const minTime = maxTime - space
          const selectTime = dateTime.getTime()
          return selectTime > maxTime || selectTime < minTime || selectTime > new Date().getTime()
        }
      }
    },
    pickerOptionsEnd() {
      const space = this.dateDayRange * dayTime // 可操作范围天数
      return {
        disabledDate: dateTime => {
          // 如果存在开始时间, 最小时间是开始时间; 否则最小时间就是当天的 00:00:00;
          const timeStart = this.slotParams.operatingStartTime
          const startDate = new Date(timeStart || this.$taday.start)
          const selectTime = dateTime.getTime()
          const minTime = startDate.getTime()
          const maxTime = startDate.getTime() + space
          return selectTime < minTime || selectTime > maxTime || selectTime > new Date().getTime()
        }
      }
    },
    listOpt() {
      return {
        search: false,
        menuBtnType: 'text', // 更改按钮图标为文字
        pagination: true,
        // menu: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
        searchExpand: false,
        tableHeight: 400,
        menuWidth: 80,
        column: [
          {
            label: '申请时间',
            prop: 'createTime',
            width: 100
          },
          {
            label: '模块名称',
            prop: 'modelName'
          },
          {
            label: '文件名称',
            prop: 'jobName'
          },
          {
            label: '状态',
            prop: 'statusType',
            formatter: (row) => {
              const map = new Map([
                [-1, `<i class="dot red"></i> 失败`],
                [0, `<i class="dot"></i> 排队中`],
                [1, `<i class="dot active"></i> 成功`],
                [2, `<i class="el-icon-loading"></i> 进行中`],
                [3, `<i class="dot"></i> 已取消`]
              ]);
              return map.get(row.statusType);
            }
          },
          {
            label: '生成时间',
            prop: 'fileGenerateTime'
          }
        ]
      };
    }
  }
}
</script>

<style lang="scss" scoped>

.export-warning {
  margin: 10px 0;

  .el-alert {
    margin: 0;
  }
}
</style>
